import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useRemoteCollectionStore = create()(
    persist(
        (set) => ({
            refetchRemoteCollections: false,
            storeRefetchRemoteCollections: (refetchRemoteCollections) => set(() => ({ refetchRemoteCollections: refetchRemoteCollections })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query }))
        }),
        {
            name: 'remote-collection-storage'
        }
    )
);


export default useRemoteCollectionStore;